module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title_fit":"{fit} 핏으로 입고 싶다면,\\n{size} 사이즈를 추천해요.","subtitle_secondary":"{size} 사이즈도 고려해 볼 수 있어요.","title_single":"고객님 체형에는\\n{size} 사이즈를 추천해요.","subtitle_single":"현재 가장 적합한 사이즈예요.","title_empty":"추천 가능한 사이즈를\\n찾지 못했어요.","subtitle_empty":"사이즈 정보를 확인해 주세요.","body_info":"{height}cm/{weight}kg/{fit} 핏","fit_names":{"slim":"슬림","basic":"기본","loose":"루즈"}}}')
  delete Component.options._Ctor
}
